import imkt from "../../imkt";

export default class LinkButtonAnchor {
    domRoot: HTMLElement;
    params: any;
    anchorLink: HTMLAnchorElement | null;

    constructor(domRoot: HTMLElement, params: any) {
        this.domRoot = domRoot;
        this.params = { ...params };
        this.anchorLink = domRoot.querySelector('a.component__link') as HTMLAnchorElement;
        this.init();
    }

    async init() {
        await this.bindAttributionEvent();
        await this.bindStatsigEvaluationEvent();
    }

    bindAttributionEvent = async () => {
        if (this.anchorLink && 
            this.params.isExperimentAttributionOnLinkButton && 
            !this.params.isEnableExperimentOnLinkButton &&
            !this.params.isEnableFGOnLinkButton
        ) {
            try {
                this.anchorLink.addEventListener("click", async () => {
                    await this.applyExperimentAttributionOnLinkButton();
                });
            } catch (e) {
                console.error("Unable to enable experiment attribution", e);
            }
        }
    } 

    bindStatsigEvaluationEvent = async () => {
        if((this.params.isEnableExperimentOnLinkButton || this.params.isEnableFGOnLinkButton) && 
            !this.params.isExperimentAttributionOnLinkButton &&
            this.params.isAnchorLink
        ) {
            const isLinkComponentHidden = this.anchorLink?.classList.contains('link-hidden');
            try {
                if(this.params.isEnableExperimentOnLinkButton) {
                    await this.applyExperimentOnLinkButton();
                } else if (this.params.isEnableFGOnLinkButton) {
                    await this.applyFeatureGateOnLinkButton();
                }
            } catch (e) {
                console.error("Unable to validate feature gate", e);
            }
            if(isLinkComponentHidden) this.anchorLink?.classList.remove('link-hidden');
        }
    }

    applyExperimentOnLinkButton = async () => {
        const isAbleToRunExperiment = await imkt.utils.featureGate.getExperimentValue(
            this.params.experimentName,
            this.params.experimentParameterName,
            false
        ); 

        if(isAbleToRunExperiment && this.anchorLink) {
            if(this.params.altLinkText !== "") this.anchorLink.innerHTML = this.params.altLinkText;
            if(this.params.altHref !== "") this.anchorLink.href = this.params.altHref;
        }
    }

    applyExperimentAttributionOnLinkButton = async () => {
        if (typeof ace !== "undefined") {

            ace.analytics.GASv3.sendTrackEvent(
              'exposed',
              this.params.experimentParameterName,
              this.params.experimentName,
              {
                eventContainer: this.params.experimentName,
                group: this.params.attributionGroup,
              },
              false);
          }
    }

    applyFeatureGateOnLinkButton = async () => {
        const isAbleToCheckFeatureGate = await imkt.utils.featureGate.checkGate(
            this.params.featureGateName
        );
        if(isAbleToCheckFeatureGate && this.anchorLink) {
            if(this.params.altLinkText !== "") this.anchorLink.innerHTML = this.params.altLinkText;
            if(this.params.altHref !== "") this.anchorLink.href = this.params.altHref;
        }
    }
}
